import { instance } from "libs/api";

import { ApiRoutesProductSets } from "../../constants";
import { CreateProductSetBody } from "./createProductSet.types";

export const requestCreateProductSet = async (
  body: CreateProductSetBody
): Promise<void> => {
  return await instance.post(ApiRoutesProductSets.ProductSets, body);
};
